module.exports = __webpack_public_path__ + "img/1_6_1.a60c6b45.jpg";